import { useCallback, useEffect } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'next-i18next';

import { RWMemberRoleKeys } from '@restworld/utility-types';
import { closeAllToasts, showToast } from '@restworld/ui-ds-base';

import useUpdateEmployerUserContact from './use-update-employer-user-contact';
import { useCollaboratorActionModal } from '../collaborators.atoms';

function useEditCollaboratorPermissionLevelForm(userId: string, level?: RWMemberRoleKeys) {
  const { t } = useTranslation('collaborators-page');
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<EditPermissionLevelFormValues>({
    mode: 'onTouched',
    defaultValues: { permissionLevel: level },
  });
  const { mutate, isPending, isSuccess } = useUpdateEmployerUserContact();
  const { closeCollaboratorActionModal } = useCollaboratorActionModal();

  const onSubmit: SubmitHandler<EditPermissionLevelFormValues> = useCallback(
    (values) => {
      const { permissionLevel } = values;
      mutate({ role_rw_key: permissionLevel, id: userId });
    },
    [mutate, userId]
  );

  useEffect(() => {
    if (isSuccess) {
      closeAllToasts();
      showToast(t('we_have_updated_the_collaborators_permission'), 'success', {
        position: 'top-right',
        autoClose: 3000,
      });
      closeCollaboratorActionModal();
    }
  }, [closeCollaboratorActionModal, isSuccess, t]);

  return { onSubmit, control, handleSubmit, isValid, isPending };
}

export default useEditCollaboratorPermissionLevelForm;

interface EditPermissionLevelFormValues {
  permissionLevel: RWMemberRoleKeys;
}
